import { render, staticRenderFns } from "./DeletionConfirmationLayout.vue?vue&type=template&id=544d6fa0"
import script from "./DeletionConfirmationLayout.vue?vue&type=script&lang=js"
export * from "./DeletionConfirmationLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports